var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{staticClass:"scrollable",on:{"set_user":_vm.saveUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }